module.exports = __webpack_public_path__ + "img/logo140x50.2ac84c16.png";